import React, { FC, useCallback } from 'react';
import styled from 'styled-components/native';

import { ELoginAs } from '@webtrader/core/constants/account';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { authService } from '@webtrader/core/services/auth';
import { companyService } from '@webtrader/core/services/company';

import Button from '@/components/Button';
import { goBack, useExperienceDemoCompletionRouteParams } from '@/utils/navigation';

import NavigationHeader from '../../Header';
import ExperienceDemoCompletionContent from './Content';

const ExperienceDemoCompletionScreen: FC = () => {
  const params = useExperienceDemoCompletionRouteParams();

  const { title, subTitle, accountDetails, setNeedUpdateFields } = params || {};

  const { t } = useTranslation();

  const { login, password } = accountDetails || {};

  const onLoginIn = useCallback(() => {
    const { mt5DemoLoginConfig, mt4DemoLoginConfig } = companyService.context.access;

    const demoLoginType = authService.getDemoLoginTypeFromCompanyAccess({ mt5DemoLoginConfig, mt4DemoLoginConfig });

    authService.setLoginAs(demoLoginType as ELoginAs);
    authService.setInitialContext(false);
    authService.setPrefilledValueDemoAccount(login, password);
    authService.resetloginErrorCode();
    setNeedUpdateFields?.(true);

    goBack();
  }, [login, password, setNeedUpdateFields]);

  return (
    <Container>
      <Screen>
        <NavigationHeader />
      </Screen>
      <ScrollView>
        <StyledFormContainer>
          <ExperienceDemoCompletionContent title={title} subTitle={subTitle} accountDetails={accountDetails} />
          <StyledButtonWrapper>
            <Button onPress={onLoginIn}>{t('LOGIN')}</Button>
          </StyledButtonWrapper>
        </StyledFormContainer>
      </ScrollView>
    </Container>
  );
};

export default ExperienceDemoCompletionScreen;

const ScrollView = styled.ScrollView`
  background-color: ${({ theme }) => theme.colors.background[0]};
  margin-top: ${dynamicSize.convertSize(8)}px;
`;

const Container = styled.View`
  flex: 1;
`;

const Screen = styled.View`
  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;

const StyledFormContainer = styled.View`
  padding: ${dynamicSize.convertSize(12)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
`;

const StyledButtonWrapper = styled.View`
  margin-top: ${dynamicSize.convertSize(24)}px;
`;
